module.exports = __webpack_public_path__ + "static/flask.580cc92e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/flask.svg
// module id = 738
// module chunks = 263791100135453